module.exports = __webpack_public_path__ + "static/media/logo2.1b179063.png";